module.exports = __webpack_public_path__ + "static/media/tini-terre_forti.dbe68128.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/tini-terre_forti.jpg
// module id = 817
// module chunks = 0